exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".plan-price[data-v-5d680cb6]{position:relative;text-align:center}.plan-price .plan-price-value[data-v-5d680cb6]{position:absolute;font:normal normal 800 2.8rem/56px Muli;color:#0f7bff;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:100%;left:0;top:calc(62% - 50px)}.plan-price .plan-price-value sup[data-v-5d680cb6]{font-size:1.4rem;top:-.2em}.plan-price .plan-price-value span[data-v-5d680cb6]{font:normal normal 800 2.8rem/56px Muli;color:#0f7bff}.plan-price .plan-price-value small[data-v-5d680cb6]{position:absolute;top:-45px;font-size:17px;left:70px;text-decoration:line-through!important;opacity:.9;color:#fd1a51}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5d680cb6","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/office/js/components/dashboard-v5/upgrade/PlanListItemPrice.vue
// module id = gkJD
// module chunks = 0